'use strict';

const $ = require('jquery');
const Template = require('./../lib/template');

class EnergyLabelCalculator {

    constructor() {

        let self = this;
        this.$currentEnergyLabel = $('.js-set-current-energy-label');
        this.$calculatorForm = $('.js-calculator-form');
        this.$goalEnergyLabel = $('.js-set-goal-energy-label');
        this.$calculatorReport =  $('.js-calculator-report');

        const $startCalculatorFormScreen = $('.js-open-calculator-form');

        if ($('.ce-energy-label-calculator').length > 0) {
            $startCalculatorFormScreen.on('click', '.button', function(event) {
                event.preventDefault();

                $startCalculatorFormScreen.hide();
                self.$calculatorForm.show();
            });

            self.$currentEnergyLabel.on('change', function() {
                self.updateCurrentEnergyLabel('current', $(this).val());
            });

            self.$goalEnergyLabel.on('change', function() {
                self.updateCurrentEnergyLabel('goal', $(this).val());
            });

            $('.js-get-new-energy-label').on('blur', function() {
                self.getEnergyLabel($(this).val());
            });

            $('.js-call-calculator-form').on('submit', function(event) {
               event.preventDefault();

               self.getEnergyLabelReport();
            });

            $('.js-show-calculator-form').on('click', function(event) {
               event.preventDefault();

               self.$calculatorReport.hide();
               self.$calculatorForm.show();
               $('body, html').animate({scrollTop: self.$calculatorForm.offset().top}, 'slow');
               $('.js-calculator-form input').first().trigger('focus');
               self.$calculatorReport.removeClass('comparison-tab')
               self.$calculatorReport.removeClass('savings-tab')
            });

            $('.js-show-savings-tab').on('click', function() {
               $('#panel2-label').trigger('click');
               if(!self.$calculatorReport.hasClass('savings-tab')) {
                   self.$calculatorReport.addClass('savings-tab')
                   self.$calculatorReport.removeClass('comparison-tab')
               }
            });

            $('#panel1-label').on('click', function() {
               if(!self.$calculatorReport.hasClass('comparison-tab')) {
                   self.$calculatorReport.addClass('comparison-tab')
                   self.$calculatorReport.removeClass('savings-tab')
               }
            });
        }

    }

    updateCurrentEnergyLabel(type, value) {
        if (type === 'current') {
            $('.js-get-current-energy-label').text(value);
        } else if (type === 'goal') {
            $('.js-get-goal-energy-label').text(value);
        }
    }

    getEnergyLabel(buildYear) {
        let self = this;

        return $.ajax({
            url: '/api/energy_label_calculator/build_year_to_energy_label/' + buildYear,
            contentType: 'application/json'
        }).done(function (data) {
            self.$currentEnergyLabel.val(data);
            self.updateCurrentEnergyLabel('current', data);
        }).error(function (error) {
            console.log(error);
            self.$currentEnergyLabel.val('');
            self.updateCurrentEnergyLabel('current', '');
        });

    }

    getEnergyLabelReport() {
        let self = this;

        let currentEnergyLabel = self.$currentEnergyLabel.val();
        let goalEnergyLabel = self.$goalEnergyLabel.val();
        let officeArea = $('.js-get-office-area').val();
        let gasUsage = $('.js-get-gas-use').val();
        let electricityUsage = $('.js-get-electricity-use').val();

        return $.ajax({
            url: '/api/energy_label_calculator/calculate/',
            data: {
                'office_area': officeArea,
                'current_energy_label': currentEnergyLabel,
                'gas_use': gasUsage,
                'electricity_use': electricityUsage,
                'to_energy_label': goalEnergyLabel,
                'save_data': true
            },
            method: 'POST',
            contentType: 'application/x-www-form-urlencoded'
        }).done(function (data) {
            self.$calculatorForm.hide();
            self.$calculatorReport.show();

            if(!self.$calculatorReport.hasClass('comparison-tab')) {
                self.$calculatorReport.addClass('comparison-tab')
                self.$calculatorReport.removeClass('savings-tab')
            }

            const comparison = data.comparison;
            const savings = data.savings;

            const comparisonElectric = comparison.electric;
            const comparisonGas = comparison.gas;
            const comparisonTotal = comparison.total;

            self.generateEnergyLabelContent(comparisonElectric, 'comparison-electric');
            self.generateEnergyLabelContent(comparisonGas, 'comparison-gas');
            self.generateEnergyLabelContent(comparisonTotal, 'comparison-total');
            self.generateEnergyLabelContent(savings, 'savings');
        }).error(function (error) {
            console.log(error);
        });

    }

    generateEnergyLabelContent(object, prefix) {
        for (const [key, value] of Object.entries(object)) {
            let name = `.js-${prefix}-${key}`;
            if(key === 'measures_text') {
                $(name).html(value);
            } else {
                $(name).text(value);
            }
        }
    }

}

module.exports = EnergyLabelCalculator;
